import JudgesCards from "./JudgesCards";
import { JUDGES_CLOSER, JUDGES_LIVE_NOTE } from "../lib/judges";

/**
 * The Builderfest brief, below the World.
 *
 * Founder's ruling: a run-on wall of small type is boring, and this panel also
 * appears as the corner pill's popup — so it has to earn attention twice. It is
 * built as a fanned STAND of overlapping cards, laid on the parchment at
 * different angles, that straighten and lift under the cursor. Big type. Big
 * ghosted numerals. A judge should want to read it.
 */
export const JudgesLight = () => (
    <section
      id="judges"
      data-testid="judges-light"
      className="relative overflow-hidden border-b-[3px] border-[#8a4a00] px-6 py-8 md:px-16 md:py-12"
      style={{ background: "linear-gradient(180deg, #f6f1e4 0%, #e6dbc2 100%)" }}
    >
      {/* a warm pool of light behind the stand, so the cards sit ON something */}
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 top-1/4"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 55%, rgba(255,228,168,0.55) 0%, rgba(255,228,168,0) 72%)",
        }}
      />

      <div className="relative mx-auto max-w-[1240px]">
        <div className="flex flex-wrap items-end justify-between gap-6 border-b border-[rgba(36,18,6,0.2)] pb-7">
          <div className="flex flex-col gap-2.5">
            <p className="mono text-[10px] uppercase tracking-[0.32em] text-[#8a4a00]">
              Builderfest · For the judges
            </p>
            <h2 className="engrave text-[clamp(1.9rem,3.4vw,3rem)] font-bold leading-[1.05] tracking-[0.04em] text-[#241206]">
              Two doors are open.
              <br className="hidden sm:block" /> Four minutes.
            </h2>
          </div>

          {/* Small marquee tucked top-right — nod to the room we came from,
              not a takeover. Hairline gold frame so cobalt sits on parchment. */}
          <div className="flex flex-col items-end gap-2">
            <a
              href="https://emergent.sh/builderfest"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="judges-builderfest-marquee"
              className="group relative block w-[220px] overflow-hidden rounded-[4px] border border-[rgba(138,74,0,0.55)] shadow-[0_10px_24px_-16px_rgba(20,10,4,0.55)] ring-1 ring-[rgba(255,214,140,0.35)] transition-transform duration-300 hover:-translate-y-[2px] sm:w-[260px]"
              style={{ background: "#1a1cff" }}
              aria-label="Emergent x Kevin O'Leary — Builderfest"
            >
              <img
                src="/brand/builderfest-emergent-oleary.jpg"
                alt="Emergent x Kevin O'Leary · Builderfest"
                className="block h-auto w-full select-none"
                draggable={false}
              />
            </a>
            <p className="mono max-w-[260px] text-right text-[10px] uppercase leading-relaxed tracking-[0.18em] text-[rgba(36,18,6,0.55)]">
              Three tests. Temporary panel — it comes down after judging.
            </p>
          </div>
        </div>

        <div className="mt-14" data-testid="judges-light-stand">
          <JudgesCards />
        </div>

        <div className="mt-16 grid gap-8 border-t border-[rgba(36,18,6,0.16)] pt-8 md:grid-cols-2">
          <p className="text-[17px] leading-[1.65] text-[#412510]">{JUDGES_LIVE_NOTE}</p>
          <p className="text-[17px] leading-[1.65] text-[#412510]">{JUDGES_CLOSER}</p>
        </div>
      </div>
    </section>
);

export default JudgesLight;
